import { type FieldError, type UseFormRegister } from 'react-hook-form'

import { BankClosureStrategies } from '../../types/payroll'

type BankClosureStrategyInputProps = {
  register: UseFormRegister<any>
  error?: FieldError
}

const bankClosureStrategyOptions = [
  {
    id: 'previous',
    value: BankClosureStrategies.Before,
    label: 'Previous business day'
  },
  {
    id: 'next',
    value: BankClosureStrategies.After,
    label: 'Next business day'
  },
  {
    id: 'closest',
    value: BankClosureStrategies.Closest,
    label: 'Closest business day',
    description: 'On Sundays and Monday holidays, employees are paid on the next business day. On Saturdays and other holidays, employees are paid on the previous business day.'
  }
]

export const BankClosureStrategyInput = ({
  register,
  error
}: BankClosureStrategyInputProps) => (
  <div className='space-y-4 col-span-3 lg:col-span-2'>
    <label className='label-default font-medium text-ds-text-secondary block'>
      On weekends and holidays, payments are made on:
    </label>

    <div className='space-y-4'>
      {bankClosureStrategyOptions.map(({ id, value, label, description }) => (
        <div key={id}>
          <label className='flex items-center cursor-pointer label-default font-medium text-ds-text-secondary' htmlFor={id}>
            <div className='relative flex items-center'>
              <input
                {...register('bankClosureStrategy', { required: true })}
                id={id}
                value={value}
                type='radio'
                className='mr-2 text-thatch-purple focus:ring-thatch-purple'
              />
              <span>{label}</span>
            </div>
          </label>
          {description && (
            <span className='text-sm label-default text-ds-text-secondary pl-6 mt-1 block'>
              {description}
            </span>
          )}
        </div>
      ))}
    </div>
    {error && <p className='text-red-500 text-xs'>This field is required</p>}
  </div>
)
